var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.gameUrl)?_c('iframe',{attrs:{"src":_vm.gameUrl,"allow":"autoplay; fullscreen","allowfullscreen":"true","webkitallowfullscreen":"true","mozallowfullscreen":"true"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib??vue-loader-options!./skins/bulmasite/components/common/galaxsys/galaxsys-frame.vue?vue&type=template&id=8ff2c1ec
// module id = 6noL
// module chunks = 0